import * as api from '../api/agent';
import * as eventApi from '@modules/events/api/event';

import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

export const AGENT_SEARCH_OPTIONS_FETCH_START =
  'APPRAISAL/AGENT_SEARCH_OPTIONS_FETCH_START';
export const AGENT_SEARCH_OPTIONS_FETCH_SUCCESS =
  'APPRAISAL/AGENT_SEARCH_OPTIONS_FETCH_SUCCESS';
export const AGENT_SEARCH_OPTIONS_FETCH_ERROR =
  'APPRAISAL/AGENT_SEARCH_OPTIONS_FETCH_ERROR';

export const AGENT_SEARCH_START = 'APPRAISAL/AGENT_SEARCH_START';
export const AGENT_SEARCH_SUCCESS = 'APPRAISAL/AGENT_SEARCH_SUCCESS';
export const AGENT_SEARCH_ERROR = 'APPRAISAL/AGENT_SEARCH_ERROR';

export const AGENT_TAGS_FETCH_START = 'APPRAISAL/AGENT_TAGS_FETCH_START';
export const AGENT_TAGS_FETCH_SUCCESS = 'APPRAISAL/AGENT_TAGS_FETCH_SUCCESS';
export const AGENT_TAGS_FETCH_ERROR = 'APPRAISAL/AGENT_TAGS_FETCH_ERROR';

export const AGENT_FIELDS_FETCH_START = 'APPRAISAL/AGENT_FIELDS_FETCH_START';
export const AGENT_FIELDS_FETCH_SUCCESS =
  'APPRAISAL/AGENT_FIELDS_FETCH_SUCCESS';
export const AGENT_FIELDS_FETCH_ERROR = 'APPRAISAL/AGENT_FIELDS_FETCH_ERROR';

export const AGENT_CHANGE_CURRENT_PAGE = 'APPRAISAL/AGENT_CHANGE_CURRENT_PAGE';
export const AGENT_CHANGE_SORT_MODEL = 'APPRAISAL/AGENT_CHANGE_SORT_MODEL';
export const AGENT_CHANGE_PAGE_SIZE = 'APPRAISAL/AGENT_CHANGE_PAGE_SIZE';

export const AGENT_RESET_DATA = 'APPRAISAL/AGENT_RESET_DATA';
export const AGENT_FETCH_START = 'APPRAISAL/AGENT_FETCH_START';
export const AGENT_FETCH_SUCCESS = 'APPRAISAL/AGENT_FETCH_SUCCESS';
export const AGENT_FETCH_ERROR = 'APPRAISAL/AGENT_FETCH_ERROR';

export const AGENT_UPDATE_START = 'APPRAISAL/AGENT_UPDATE_START';
export const AGENT_UPDATE_SUCCESS = 'APPRAISAL/AGENT_UPDATE_SUCCESS';
export const AGENT_UPDATE_ERROR = 'APPRAISAL/AGENT_UPDATE_ERROR';

export const AGENT_DELETE_START = 'APPRAISAL/AGENT_DELETE_START';
export const AGENT_DELETE_SUCCESS = 'APPRAISAL/AGENT_DELETE_SUCCESS';
export const AGENT_DELETE_ERROR = 'APPRAISAL/AGENT_DELETE_ERROR';

export const AGENT_NOTES_FETCH_START = 'APPRAISAL/AGENT_NOTES_FETCH_START';
export const AGENT_NOTES_FETCH_SUCCESS = 'APPRAISAL/AGENT_NOTES_FETCH_SUCCESS';
export const AGENT_NOTES_FETCH_ERROR = 'APPRAISAL/AGENT_NOTES_FETCH_ERROR';

export const AGENT_PROPERTIES_FETCH_START =
  'APPRAISAL/AGENT_PROPERTIES_FETCH_START';
export const AGENT_PROPERTIES_FETCH_SUCCESS =
  'APPRAISAL/AGENT_PROPERTIES_FETCH_SUCCESS';
export const AGENT_PROPERTIES_FETCH_ERROR =
  'APPRAISAL/AGENT_PROPERTIES_FETCH_ERROR';

export const AGENT_NOTE_ADD_START = 'APPRAISAL/AGENT_NOTE_ADD_START';
export const AGENT_NOTE_ADD_SUCCESS = 'APPRAISAL/AGENT_NOTE_ADD_SUCCESS';
export const AGENT_NOTE_ADD_ERROR = 'APPRAISAL/AGENT_NOTE_ADD_ERROR';

export const AGENT_NOTE_UPDATE_START = 'APPRAISAL/AGENT_NOTE_UPDATE_START';
export const AGENT_NOTE_UPDATE_SUCCESS = 'APPRAISAL/AGENT_NOTE_UPDATE_SUCCESS';
export const AGENT_NOTE_UPDATE_ERROR = 'APPRAISAL/AGENT_NOTE_UPDATE_ERROR';

export const AGENT_TAG_UPDATE_START = 'APPRAISAL/AGENT_TAG_UPDATE_START';
export const AGENT_TAG_UPDATE_SUCCESS = 'APPRAISAL/AGENT_TAG_UPDATE_SUCCESS';
export const AGENT_TAG_UPDATE_ERROR = 'APPRAISAL/AGENT_TAG_UPDATE_ERROR';

export const AGENT_NOTE_DELETE_START = 'APPRAISAL/AGENT_NOTE_DELETE_START';
export const AGENT_NOTE_DELETE_SUCCESS = 'APPRAISAL/AGENT_NOTE_DELETE_SUCCESS';
export const AGENT_NOTE_DELETE_ERROR = 'APPRAISAL/AGENT_NOTE_DELETE_ERROR';

export const AGENT_VALIDATE_START = 'APPRAISAL/AGENT_VALIDATE_START';
export const AGENT_VALIDATE_SUCCESS = 'APPRAISAL/AGENT_VALIDATE_SUCCESS';
export const AGENT_VALIDATE_ERROR = 'APPRAISAL/AGENT_VALIDATE_ERROR';

export const AGENT_FETCH_PROPERTIES_BY_NAME_START =
  'APPRAISAL/AGENT_FETCH_PROPERTIES_BY_NAME_START';
export const AGENT_FETCH_PROPERTIES_BY_NAME_SUCCESS =
  'APPRAISAL/AGENT_FETCH_PROPERTIES_BY_NAME_SUCCESS';
export const AGENT_FETCH_PROPERTIES_BY_NAME_ERROR =
  'APPRAISAL/AGENT_FETCH_PROPERTIES_BY_NAME_ERROR';

export const AGENT_FETCH_PROPERTY_AGENT_START =
  'APPRAISAL/AGENT_FETCH_PROPERTY_AGENT_START';
export const AGENT_FETCH_PROPERTY_AGENT_SUCCESS =
  'APPRAISAL/AGENT_FETCH_PROPERTY_AGENT_SUCCESS';
export const AGENT_FETCH_PROPERTY_AGENT_ERROR =
  'APPRAISAL/AGENT_FETCH_PROPERTY_AGENT_ERROR';

export const AGENT_DELETE_PROPERTY_AGENT_START =
  'APPRAISAL/AGENT_DELETE_PROPERTY_AGENT_START';
export const AGENT_DELETE_PROPERTY_AGENT_SUCCESS =
  'APPRAISAL/AGENT_DELETE_PROPERTY_AGENT_SUCCESS';
export const AGENT_DELETE_PROPERTY_AGENT_ERROR =
  'APPRAISAL/AGENT_DELETE_PROPERTY_AGENT_ERROR';

export const AGENT_FETCH_PROPERTY_ACCOUNT_AGENT_START =
  'APPRAISAL/AGENT_FETCH_PROPERTY_ACCOUNT_AGENT_START';
export const AGENT_FETCH_PROPERTY_ACCOUNT_AGENT_SUCCESS =
  'APPRAISAL/AGENT_FETCH_PROPERTY_ACCOUNT_AGENT_SUCCESS';
export const AGENT_FETCH_PROPERTY_ACCOUNT_AGENT_ERROR =
  'APPRAISAL/AGENT_FETCH_PROPERTY_ACCOUNT_AGENT_ERROR';

export const AGENT_UPDATE_PROPERTY_ACCOUNT_AGENT_START =
  'APPRAISAL/AGENT_UPDATE_PROPERTY_ACCOUNT_AGENT_START';
export const AGENT_UPDATE_PROPERTY_ACCOUNT_AGENT_SUCCESS =
  'APPRAISAL/AGENT_UPDATE_PROPERTY_ACCOUNT_AGENT_SUCCESS';
export const AGENT_UPDATE_PROPERTY_ACCOUNT_AGENT_ERROR =
  'APPRAISAL/AGENT_UPDATE_PROPERTY_ACCOUNT_AGENT_ERROR';

export const AGENT_FETCH_PROPERTY_ACCOUNT_FILES_START =
  'APPRAISAL/AGENT_FETCH_PROPERTY_ACCOUNT_FILES_START';
export const AGENT_FETCH_PROPERTY_ACCOUNT_FILES_SUCCESS =
  'APPRAISAL/AGENT_FETCH_PROPERTY_ACCOUNT_FILES_SUCCESS';
export const AGENT_FETCH_PROPERTY_ACCOUNT_FILES_ERROR =
  'APPRAISAL/AGENT_FETCH_PROPERTY_ACCOUNT_FILES_ERROR';

export const AGENT_INSERT_PROPERTY_ACCOUNT_FILE_START =
  'APPRAISAL/AGENT_INSERT_PROPERTY_ACCOUNT_FILE_START';
export const AGENT_INSERT_PROPERTY_ACCOUNT_FILE_SUCCESS =
  'APPRAISAL/AGENT_INSERT_PROPERTY_ACCOUNT_FILE_SUCCESS';
export const AGENT_INSERT_PROPERTY_ACCOUNT_FILE_ERROR =
  'APPRAISAL/AGENT_INSERT_PROPERTY_ACCOUNT_FILE_ERROR';

export const AGENT_DELETE_PROPERTY_ACCOUNT_FILE_START =
  'APPRAISAL/AGENT_DELETE_PROPERTY_ACCOUNT_FILE_START';
export const AGENT_DELETE_PROPERTY_ACCOUNT_FILE_SUCCESS =
  'APPRAISAL/AGENT_DELETE_PROPERTY_ACCOUNT_FILE_SUCCESS';
export const AGENT_DELETE_PROPERTY_ACCOUNT_FILE_ERROR =
  'APPRAISAL/AGENT_DELETE_PROPERTY_ACCOUNT_FILE_ERROR';

export const AGENT_DOWNLOAD_PROPERTY_ACCOUNT_FILE_START =
  'APPRAISAL/AGENT_DOWNLOAD_PROPERTY_ACCOUNT_FILE_START';
export const AGENT_DOWNLOAD_PROPERTY_ACCOUNT_FILE_SUCCESS =
  'APPRAISAL/AGENT_DOWNLOAD_PROPERTY_ACCOUNT_FILE_SUCCESS';
export const AGENT_DOWNLOAD_PROPERTY_ACCOUNT_FILE_ERROR =
  'APPRAISAL/AGENT_DOWNLOAD_PROPERTY_ACCOUNT_FILE_ERROR';

export const AGENT_UPDATE_PROPERTY_ACCOUNT_FILE_START =
  'APPRAISAL/AGENT_UPDATE_PROPERTY_ACCOUNT_FILE_START';
export const AGENT_UPDATE_PROPERTY_ACCOUNT_FILE_SUCCESS =
  'APPRAISAL/AGENT_UPDATE_PROPERTY_ACCOUNT_FILE_SUCCESS';
export const AGENT_UPDATE_PROPERTY_ACCOUNT_FILE_ERROR =
  'APPRAISAL/AGENT_UPDATE_PROPERTY_ACCOUNT_FILE_ERROR';

export const AGENT_FETCH_AGENTS_BY_NAME_START =
  'APPRAISAL/AGENT_FETCH_AGENTS_BY_NAME_START';
export const AGENT_FETCH_AGENTS_BY_NAME_SUCCESS =
  'APPRAISAL/AGENT_FETCH_AGENTS_BY_NAME_SUCCESS';
export const AGENT_FETCH_AGENTS_BY_NAME_ERROR =
  'APPRAISAL/AGENT_FETCH_AGENTS_BY_NAME_ERROR';

export const AGENT_RESET_AGENTS_BY_NAME =
  'APPRAISAL/AGENT_RESET_AGENTS_BY_NAME';

export const AGENT_FETCH_PROPERTY_ACCOUNT_NAME_LISTING_START =
  'APPRAISAL/AGENT_FETCH_PROPERTY_ACCOUNT_NAME_LISTING_START';
export const AGENT_FETCH_PROPERTY_ACCOUNT_NAME_LISTING_SUCCESS =
  'APPRAISAL/AGENT_FETCH_PROPERTY_ACCOUNT_NAME_LISTING_SUCCESS';
export const AGENT_FETCH_PROPERTY_ACCOUNT_NAME_LISTING_ERROR =
  'APPRAISAL/AGENT_FETCH_PROPERTY_ACCOUNT_NAME_LISTING_ERROR';

export const AGENT_INSERT_PROPERTY_ACCOUNT_AGENT_START =
  'APPRAISAL/AGENT_INSERT_PROPERTY_ACCOUNT_AGENT_START';
export const AGENT_INSERT_PROPERTY_ACCOUNT_AGENT_SUCCESS =
  'APPRAISAL/AGENT_INSERT_PROPERTY_ACCOUNT_AGENT_SUCCESS';
export const AGENT_INSERT_PROPERTY_ACCOUNT_AGENT_ERROR =
  'APPRAISAL/AGENT_INSERT_PROPERTY_ACCOUNT_AGENT_ERROR';

export const AGENT_INSERT_PROPERTY_LIST_ACCOUNT_AGENT_START =
  'APPRAISAL/AGENT_INSERT_PROPERTY_LIST_ACCOUNT_AGENT_START';
export const AGENT_INSERT_PROPERTY_LIST_ACCOUNT_AGENT_SUCCESS =
  'APPRAISAL/AGENT_INSERT_PROPERTY_LIST_ACCOUNT_AGENT_SUCCESS';
export const AGENT_INSERT_PROPERTY_LIST_ACCOUNT_AGENT_ERROR =
  'APPRAISAL/AGENT_INSERT_PROPERTY_LIST_ACCOUNT_AGENT_ERROR';

export const AGENT_CREATE = createRequestTypes('APPRAISAL/AGENT_CREATE');

export const fetchSearchOptions = makeApiActionCreatorV3(
  api.fetchSearchOptions,
  AGENT_SEARCH_OPTIONS_FETCH_START,
  AGENT_SEARCH_OPTIONS_FETCH_SUCCESS,
  AGENT_SEARCH_OPTIONS_FETCH_ERROR,
);
export const searchAgent = makeApiActionCreatorV3(
  api.searchAgent,
  AGENT_SEARCH_START,
  AGENT_SEARCH_SUCCESS,
  AGENT_SEARCH_ERROR,
);
export const fetchFields = makeApiActionCreatorV3(
  api.fetchFields,
  AGENT_FIELDS_FETCH_START,
  AGENT_FIELDS_FETCH_SUCCESS,
  AGENT_FIELDS_FETCH_ERROR,
);
export const fetchTags = makeApiActionCreatorV3(
  api.fetchTags,
  AGENT_TAGS_FETCH_START,
  AGENT_TAGS_FETCH_SUCCESS,
  AGENT_TAGS_FETCH_ERROR,
);
export const fetchAgent = makeApiActionCreatorV3(
  api.fetchAgent,
  AGENT_FETCH_START,
  AGENT_FETCH_SUCCESS,
  AGENT_FETCH_ERROR,
);
export const updateAgent = makeApiActionCreatorV3(
  api.updateAgent,
  AGENT_UPDATE_START,
  AGENT_UPDATE_SUCCESS,
  AGENT_UPDATE_ERROR,
);
export const deleteAgent = makeApiActionCreatorV3(
  api.deleteAgent,
  AGENT_DELETE_START,
  AGENT_DELETE_SUCCESS,
  AGENT_DELETE_ERROR,
);
export const createAgent = makeApiActionCreatorV3(
  api.createAgent,
  AGENT_CREATE[START],
  AGENT_CREATE[SUCCESS],
  AGENT_CREATE[ERROR],
);
export const fetchAgentNotes = makeApiActionCreatorV3(
  api.fetchAgentNotes,
  AGENT_NOTES_FETCH_START,
  AGENT_NOTES_FETCH_SUCCESS,
  AGENT_NOTES_FETCH_ERROR,
);
export const fetchAgentProperties = makeApiActionCreatorV3(
  api.fetchAgentProperties,
  AGENT_PROPERTIES_FETCH_START,
  AGENT_PROPERTIES_FETCH_SUCCESS,
  AGENT_PROPERTIES_FETCH_ERROR,
);
export const updateAgentNote = makeApiActionCreatorV3(
  api.updateAgentNote,
  AGENT_NOTE_UPDATE_START,
  AGENT_NOTE_UPDATE_SUCCESS,
  AGENT_NOTE_UPDATE_ERROR,
);
export const updateAgentTag = makeApiActionCreatorV3(
  api.updateAgentTag,
  AGENT_TAG_UPDATE_START,
  AGENT_TAG_UPDATE_SUCCESS,
  AGENT_TAG_UPDATE_ERROR,
);
export const addAgentNote = makeApiActionCreatorV3(
  api.addAgentNote,
  AGENT_NOTE_ADD_START,
  AGENT_NOTE_ADD_SUCCESS,
  AGENT_NOTE_ADD_ERROR,
);
export const deleteAgentNote = makeApiActionCreatorV3(
  api.deleteAgentNote,
  AGENT_NOTE_DELETE_START,
  AGENT_NOTE_DELETE_SUCCESS,
  AGENT_NOTE_DELETE_ERROR,
);
export const validateAgent = makeApiActionCreatorV3(
  api.validateAgent,
  AGENT_VALIDATE_START,
  AGENT_VALIDATE_SUCCESS,
  AGENT_VALIDATE_ERROR,
);
export const fetchAgentPropertiesByName = makeApiActionCreatorV3(
  api.fetchAgentPropertiesByName,
  AGENT_FETCH_PROPERTIES_BY_NAME_START,
  AGENT_FETCH_PROPERTIES_BY_NAME_SUCCESS,
  AGENT_FETCH_PROPERTIES_BY_NAME_ERROR,
);

export function changeCurrentPage(page) {
  return async dispatch => {
    dispatch({ type: AGENT_CHANGE_CURRENT_PAGE, data: page });
  };
}

export function changeSortModel(model) {
  return async dispatch => {
    dispatch({ type: AGENT_CHANGE_SORT_MODEL, data: model });
  };
}

export function changePageSize(page) {
  return async dispatch => {
    dispatch({ type: AGENT_CHANGE_PAGE_SIZE, data: page });
  };
}

export function resetAgentData() {
  return async dispatch => {
    dispatch({ type: AGENT_RESET_DATA });
  };
}

// agent events
export const AGENT_EVENTS_FETCH = createRequestTypes(
  'APPRAISAL/AGENT/AGENT_EVENTS_FETCH',
);

export const fetchAgentEvents = makeApiActionCreatorV3(
  api.fetchAgentEvents,
  AGENT_EVENTS_FETCH[START],
  AGENT_EVENTS_FETCH[SUCCESS],
  AGENT_EVENTS_FETCH[ERROR],
);

export const AGENT_EVENT_DELETE = createRequestTypes(
  'APPRAISAL/AGENT/AGENT_EVENT_DELETE',
);
export const deleteAgentEvent = makeApiActionCreatorV3(
  eventApi.deleteEvent,
  AGENT_EVENT_DELETE[START],
  AGENT_EVENT_DELETE[SUCCESS],
  AGENT_EVENT_DELETE[ERROR],
);

export const fetchPropertyAgent = makeApiActionCreatorV3(
  api.fetchPropertyAgent,
  AGENT_FETCH_PROPERTY_AGENT_START,
  AGENT_FETCH_PROPERTY_AGENT_SUCCESS,
  AGENT_FETCH_PROPERTY_AGENT_ERROR,
);

export const deletePropertyAgent = makeApiActionCreatorV3(
  api.deletePropertyAgent,
  AGENT_DELETE_PROPERTY_AGENT_START,
  AGENT_DELETE_PROPERTY_AGENT_SUCCESS,
  AGENT_DELETE_PROPERTY_AGENT_ERROR,
);

export const fetchPropertyAccountAgent = makeApiActionCreatorV3(
  api.fetchPropertyAccountAgent,
  AGENT_FETCH_PROPERTY_ACCOUNT_AGENT_START,
  AGENT_FETCH_PROPERTY_ACCOUNT_AGENT_SUCCESS,
  AGENT_FETCH_PROPERTY_ACCOUNT_AGENT_ERROR,
);
export const AGENT_RESET_PROPERTY_ACCOUNT_AGENT =
  'APPRAISAL/AGENT_RESET_PROPERTY_ACCOUNT_AGENT';

export const resetPropertyAccountAgent = () => ({
  type: AGENT_RESET_PROPERTY_ACCOUNT_AGENT,
});

export const updatePropertyAccountAgent = makeApiActionCreatorV3(
  api.updatePropertyAccountAgent,
  AGENT_UPDATE_PROPERTY_ACCOUNT_AGENT_START,
  AGENT_UPDATE_PROPERTY_ACCOUNT_AGENT_SUCCESS,
  AGENT_UPDATE_PROPERTY_ACCOUNT_AGENT_ERROR,
);

export const fetchPropertyAccountAgentFiles = makeApiActionCreatorV3(
  api.fetchPropertyAccountAgentFiles,
  AGENT_FETCH_PROPERTY_ACCOUNT_FILES_START,
  AGENT_FETCH_PROPERTY_ACCOUNT_FILES_SUCCESS,
  AGENT_FETCH_PROPERTY_ACCOUNT_FILES_ERROR,
);

export const insertPropertyAccountAgentFile = makeApiActionCreatorV3(
  api.insertPropertyAccountAgentFile,
  AGENT_INSERT_PROPERTY_ACCOUNT_FILE_START,
  AGENT_INSERT_PROPERTY_ACCOUNT_FILE_SUCCESS,
  AGENT_INSERT_PROPERTY_ACCOUNT_FILE_ERROR,
);

export const deletePropertyAccountAgentFile = makeApiActionCreatorV3(
  api.deletePropertyAccountAgentFile,
  AGENT_DELETE_PROPERTY_ACCOUNT_FILE_START,
  AGENT_DELETE_PROPERTY_ACCOUNT_FILE_SUCCESS,
  AGENT_DELETE_PROPERTY_ACCOUNT_FILE_ERROR,
);

export const downloadPropertyAccountAgentFile = makeApiActionCreatorV3(
  api.downloadPropertyAccountAgentFile,
  AGENT_DOWNLOAD_PROPERTY_ACCOUNT_FILE_START,
  AGENT_DOWNLOAD_PROPERTY_ACCOUNT_FILE_SUCCESS,
  AGENT_DOWNLOAD_PROPERTY_ACCOUNT_FILE_ERROR,
);

export const updatePropertyAccountAgentFile = makeApiActionCreatorV3(
  api.updatePropertyAccountAgentFile,
  AGENT_UPDATE_PROPERTY_ACCOUNT_FILE_START,
  AGENT_UPDATE_PROPERTY_ACCOUNT_FILE_SUCCESS,
  AGENT_UPDATE_PROPERTY_ACCOUNT_FILE_ERROR,
);

export const fetchAgentsByName = makeApiActionCreatorV3(
  api.fetchAgentsByName,
  AGENT_FETCH_AGENTS_BY_NAME_START,
  AGENT_FETCH_AGENTS_BY_NAME_SUCCESS,
  AGENT_FETCH_AGENTS_BY_NAME_ERROR,
);

export const resetAgentsByName = () => ({
  type: AGENT_RESET_AGENTS_BY_NAME,
});

export const fetchPropertyAccountNameListing = makeApiActionCreatorV3(
  api.fetchPropertyAccountNameListing,
  AGENT_FETCH_PROPERTY_ACCOUNT_NAME_LISTING_START,
  AGENT_FETCH_PROPERTY_ACCOUNT_NAME_LISTING_SUCCESS,
  AGENT_FETCH_PROPERTY_ACCOUNT_NAME_LISTING_ERROR,
);

export const insertPropertyAccountAgent = makeApiActionCreatorV3(
  api.insertPropertyAccountAgent,
  AGENT_INSERT_PROPERTY_ACCOUNT_AGENT_START,
  AGENT_INSERT_PROPERTY_ACCOUNT_AGENT_SUCCESS,
  AGENT_INSERT_PROPERTY_ACCOUNT_AGENT_ERROR,
);

export const insertPropertyListAccountAgent = makeApiActionCreatorV3(
  api.insertPropertyListAccountAgent,
  AGENT_INSERT_PROPERTY_LIST_ACCOUNT_AGENT_START,
  AGENT_INSERT_PROPERTY_LIST_ACCOUNT_AGENT_SUCCESS,
  AGENT_INSERT_PROPERTY_LIST_ACCOUNT_AGENT_ERROR,
);

export const FETCH_AGENT_EFIILE = createRequestTypes(
  'APPRAISAL/FETCH_AGENT_EFIILE',
);

export const fetchAgentEfile = makeApiActionCreatorV3(
  api.fetchAgentEfile,
  FETCH_AGENT_EFIILE[START],
  FETCH_AGENT_EFIILE[SUCCESS],
  FETCH_AGENT_EFIILE[ERROR],
);

export const UPDATE_AGENT_EFIILE = createRequestTypes(
  'APPRAISAL/UPDATE_AGENT_EFIILE',
);

export const updateAgentEfile = makeApiActionCreatorV3(
  api.updateAgentEfile,
  UPDATE_AGENT_EFIILE[START],
  UPDATE_AGENT_EFIILE[SUCCESS],
  UPDATE_AGENT_EFIILE[ERROR],
);

export const AGENT_EFIILE_GENERATE_PIN = createRequestTypes(
  'APPRAISAL/AGENT_EFIILE_GENERATE_PIN',
);

export const agentEfileGeneratePin = makeApiActionCreatorV3(
  api.agentEfileGeneratePin,
  AGENT_EFIILE_GENERATE_PIN[START],
  AGENT_EFIILE_GENERATE_PIN[SUCCESS],
  AGENT_EFIILE_GENERATE_PIN[ERROR],
);
